module.exports = __webpack_public_path__ + "static/media/keto-extreme-3.13f58f10.png";